import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dMonoid from "../Data.Monoid/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dOrdering from "../Data.Ordering/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dItemId from "../Restaumatic.Menu.V2.Types.ItemId/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
const productIdIsSymbol = {reflectSymbol: () => "productId"};
const productIsSymbol = {reflectSymbol: () => "product"};
const productSeqIsSymbol = {reflectSymbol: () => "productSeq"};
const ProductItemKeyIsSymbol = {reflectSymbol: () => "ProductItemKey"};
const ProductIdIsSymbol = {reflectSymbol: () => "ProductId"};
const showMaybe1 = {
  show: v => {
    if (v.tag === "Just") { return "(Just " + Restaumatic$dMenu$dV2$dTypes$dItemId.showItemId.show(v._1) + ")"; }
    if (v.tag === "Nothing") { return "Nothing"; }
    $runtime.fail();
  }
};
const showMap = /* #__PURE__ */ Data$dMap$dInternal.showMap(Data$dUUID.showUUID)(Data$dUUID.showUUID);
const ProductItemIsSymbol = {reflectSymbol: () => "ProductItem"};
const eqMap = /* #__PURE__ */ Data$dMap$dInternal.eqMap(Data$dEq.eqString)(Data$dEq.eqString);
const compare = /* #__PURE__ */ (() => Data$dMaybe.ordMaybe(Data$dOrd.ordInt).compare)();
const decodeRecordCons2 = /* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(productSeqIsSymbol)({
  decodeWithOptions: v => Foreign$dGeneric$dClass.intDecode.decode
})())(productIsSymbol);
const fold = /* #__PURE__ */ (() => Data$dFoldable.foldableArray.foldMap(Data$dMonoid.monoidOrdering)(Data$dFoldable.identity))();
const compare3 = /* #__PURE__ */ (() => Data$dMaybe.ordMaybe(Data$dOrd.ordString).compare)();
const compare4 = /* #__PURE__ */ (() => Data$dMaybe.ordMaybe(Restaumatic$dMenu$dV2$dTypes$dItemId.ordItemId).compare)();
const compare5 = /* #__PURE__ */ (() => Data$dMap$dInternal.ordMap(Data$dOrd.ordString)(Data$dOrd.ordString).compare)();
const ProductItemKey = x => x;
const ProductId = x => x;
const ProductItem = x => x;
const udecodeProductId = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(productIdIsSymbol)(Unscramble.decodeMaybe(Unscramble.decodeInt1))(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
  }
))();
const productId = v => v.productId;
const productCategoryId = v => v.productCategoryId;
const newtypeProductItemKey = {Coercible0: () => {}};
const newtypeProductItem = {Coercible0: () => {}};
const product = x => x.productItemKey.product;
const productItemKey = x => x.productItemKey;
const productName = x => x.productName;
const productPrice = x => x.productPrice;
const productSeq = x => x.productItemKey.productSeq;
const newtypeProductId = {Coercible0: () => {}};
const mkProductItemKey = prod => prodSeq => ({product: prod, productSeq: prodSeq});
const mkProductItem = template => prod => prodSeq => (
  {
    productItemKey: {product: prod, productSeq: prodSeq},
    productName: template.productName,
    productPrice: template.productPrice,
    productId: template.productId,
    productCategoryId: template.productCategoryId,
    itemId: template.itemId,
    customParameters: template.customParameters,
    isCombo: template.isCombo
  }
);
const mkProductItems = template => prod => count => Data$dFunctor.arrayMap(prodSeq => (
  {
    productItemKey: {product: prod, productSeq: prodSeq},
    productName: template.productName,
    productPrice: template.productPrice,
    productId: template.productId,
    productCategoryId: template.productCategoryId,
    itemId: template.itemId,
    customParameters: template.customParameters,
    isCombo: template.isCombo
  }
))(Data$dArray.rangeImpl(1, count));
const mkProductId = id => ({productId: Data$dMaybe.$Maybe("Just", id)});
const mkGenericProductId = {productId: Data$dMaybe.Nothing};
const itemId = v => v.itemId;
const isCombo = v => v.isCombo;
const genericProductItemKey = {to: x => x, from: x => x};
const showProductItemKey = dictShow => (
  {
    show: (() => {
      const $0 = Data$dShow$dGeneric.genericShowConstructor({
        genericShowArgs: v => ["{ product: " + dictShow.show(v.product) + ", productSeq: " + Data$dShow.showIntImpl(v.productSeq) + " " + "}"]
      })(ProductItemKeyIsSymbol);
      return x => $0["genericShow'"](x);
    })()
  }
);
const genericProductItem = {to: x => x, from: x => x};
const genericProductId = {to: x => x, from: x => x};
const showProductId = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          if (v.productId.tag === "Just") { return "{ productId: (Just " + Data$dShow.showIntImpl(v.productId._1) + ") }"; }
          if (v.productId.tag === "Nothing") { return "{ productId: Nothing }"; }
          $runtime.fail();
        })()
      ]
    })(ProductIdIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const showProductItem = dictShow => (
  {
    show: (() => {
      const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
        const $0 = showProductItemKey(dictShow);
        const $1 = (v, record) => " productItemKey: " + $0.show(record.productItemKey) + ", productName: " + Data$dShow.showStringImpl(record.productName) + ", productPrice: " + Data$dMoney$dRounded.toString(record.productPrice) + " ";
        return {
          genericShowArgs: v => [
            "{ customParameters: " + showMap.show(v.customParameters) + (v.isCombo
              ? ", isCombo: true, itemId: " + showMaybe1.show(v.itemId) + (() => {
                  if (v.productCategoryId.tag === "Just") {
                    return ", productCategoryId: (Just " + v.productCategoryId._1 + ")" + ", productId: " + showProductId.show(v.productId) + "," + $1(Type$dProxy.Proxy, v);
                  }
                  if (v.productCategoryId.tag === "Nothing") {
                    return ", productCategoryId: Nothing, productId: " + showProductId.show(v.productId) + "," + $1(Type$dProxy.Proxy, v);
                  }
                  $runtime.fail();
                })()
              : ", isCombo: false, itemId: " + showMaybe1.show(v.itemId) + (() => {
                  if (v.productCategoryId.tag === "Just") {
                    return ", productCategoryId: (Just " + v.productCategoryId._1 + ")" + ", productId: " + showProductId.show(v.productId) + "," + $1(Type$dProxy.Proxy, v);
                  }
                  if (v.productCategoryId.tag === "Nothing") {
                    return ", productCategoryId: Nothing, productId: " + showProductId.show(v.productId) + "," + $1(Type$dProxy.Proxy, v);
                  }
                  $runtime.fail();
                })()) + "}"
          ]
        };
      })())(ProductItemIsSymbol);
      return x => $0["genericShow'"](x);
    })()
  }
);
const functorProductItemKey = {map: f => m => ({...m, product: f(m.product)})};
const eqProductItemKey = dictEq => ({eq: x => y => dictEq.eq(x.product)(y.product) && x.productSeq === y.productSeq});
const ordProductItemKey = dictOrd => {
  const $0 = dictOrd.Eq0();
  const eqProductItemKey1 = {eq: x => y => $0.eq(x.product)(y.product) && x.productSeq === y.productSeq};
  return {
    compare: (() => {
      const $1 = Data$dOrd.ordRecord()((() => {
        const $1 = dictOrd.Eq0();
        const eqRowCons2 = {eqRecord: v => ra => rb => $1.eq(ra.product)(rb.product) && ra.productSeq === rb.productSeq};
        return {
          compareRecord: v => ra => rb => {
            const left = dictOrd.compare(ra.product)(rb.product);
            if (left.tag === "LT" || left.tag === "GT" || !(left.tag === "EQ")) { return left; }
            const left$1 = Data$dOrd.ordInt.compare(ra.productSeq)(rb.productSeq);
            if (left$1.tag === "LT" || left$1.tag === "GT" || !(left$1.tag === "EQ")) { return left$1; }
            return Data$dOrdering.EQ;
          },
          EqRecord0: () => eqRowCons2
        };
      })());
      return x => y => $1.compare(x)(y);
    })(),
    Eq0: () => eqProductItemKey1
  };
};
const eqProductId = {
  eq: x => y => {
    if (x.productId.tag === "Nothing") { return y.productId.tag === "Nothing"; }
    if (x.productId.tag === "Just") {
      if (y.productId.tag === "Just") { return x.productId._1 === y.productId._1; }
      return false;
    }
    return false;
  }
};
const eqProductItem = dictEq => (
  {
    eq: x => y => eqMap.eq(x.customParameters)(y.customParameters) && x.isCombo === y.isCombo && (() => {
      if (x.itemId.tag === "Nothing") { return y.itemId.tag === "Nothing"; }
      if (x.itemId.tag === "Just") {
        if (y.itemId.tag === "Just") {
          if (x.itemId._1.tag === "ProductItem") {
            if (y.itemId._1.tag === "ProductItem") { return x.itemId._1._1 === y.itemId._1._1; }
            return false;
          }
          if (x.itemId._1.tag === "ComboItem") {
            if (y.itemId._1.tag === "ComboItem") { return x.itemId._1._1 === y.itemId._1._1; }
            return false;
          }
          return false;
        }
        return false;
      }
      return false;
    })() && (() => {
      if (x.productCategoryId.tag === "Nothing") { return y.productCategoryId.tag === "Nothing"; }
      if (x.productCategoryId.tag === "Just") {
        if (y.productCategoryId.tag === "Just") { return x.productCategoryId._1 === y.productCategoryId._1; }
        return false;
      }
      return false;
    })() && (() => {
      if (x.productId.productId.tag === "Nothing") { return y.productId.productId.tag === "Nothing"; }
      if (x.productId.productId.tag === "Just") {
        if (y.productId.productId.tag === "Just") { return x.productId.productId._1 === y.productId.productId._1; }
        return false;
      }
      return false;
    })() && dictEq.eq(x.productItemKey.product)(y.productItemKey.product) && x.productItemKey.productSeq === y.productItemKey.productSeq && x.productName === y.productName && x.productPrice === y.productPrice
  }
);
const ordProductId = {compare: x => y => compare(x.productId)(y.productId), Eq0: () => eqProductId};
const encodeProductItemKey = dictEncode => dictEncodeWithOptions => (
  {
    encode: Foreign$dEncoding.defaultEncode(genericProductItemKey)(Foreign$dGeneric$dClass.genericEncodeConstructor(ProductItemKeyIsSymbol)((() => {
      const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(productSeqIsSymbol)({
        encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
      }))(productIsSymbol)(dictEncodeWithOptions);
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })()))
  }
);
const encodeProductId = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericProductId)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(ProductIdIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(productIdIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    });
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeProductItemKey = dictDecode => dictDecodeWithOptions => (
  {
    decode: Foreign$dEncoding.defaultDecode(genericProductItemKey)(Foreign$dGeneric$dClass.genericDecodeConstructor(ProductItemKeyIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsRecord(Foreign$dGeneric$dClass.decodeWithOptionsRecord()(decodeRecordCons2(dictDecodeWithOptions)())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
  }
);
const decodeProductId = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericProductId)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ProductIdIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(productIdIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign$dGeneric$dClass.intDecode.decode)
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const customParameters = v => v.customParameters;
const ordProductItem = dictOrd => {
  const compare7 = ordProductItemKey(dictOrd).compare;
  const eqProductItem1 = eqProductItem(dictOrd.Eq0());
  return {
    compare: a => b => fold([
      (() => {
        const $0 = Data$dOrd.ordInt.compare(a.productPrice)(b.productPrice);
        if ($0.tag === "GT") { return Data$dOrdering.LT; }
        if ($0.tag === "EQ") { return Data$dOrdering.EQ; }
        if ($0.tag === "LT") { return Data$dOrdering.GT; }
        $runtime.fail();
      })(),
      Data$dOrd.ordString.compare(a.productName)(b.productName),
      compare3(a.productCategoryId)(b.productCategoryId),
      compare4(a.itemId)(b.itemId),
      compare5(a.customParameters)(b.customParameters),
      Data$dOrd.ordBoolean.compare(a.isCombo)(b.isCombo),
      compare7(a.productItemKey)(b.productItemKey)
    ]),
    Eq0: () => eqProductItem1
  };
};
const customParameterValues = v => customParameterId => Data$dMap$dInternal.lookup(Data$dOrd.ordString)(customParameterId)(v.customParameters);
export {
  ProductId,
  ProductIdIsSymbol,
  ProductItem,
  ProductItemIsSymbol,
  ProductItemKey,
  ProductItemKeyIsSymbol,
  compare,
  compare3,
  compare4,
  compare5,
  customParameterValues,
  customParameters,
  decodeProductId,
  decodeProductItemKey,
  decodeRecordCons2,
  encodeProductId,
  encodeProductItemKey,
  eqMap,
  eqProductId,
  eqProductItem,
  eqProductItemKey,
  fold,
  functorProductItemKey,
  genericProductId,
  genericProductItem,
  genericProductItemKey,
  isCombo,
  itemId,
  mkGenericProductId,
  mkProductId,
  mkProductItem,
  mkProductItemKey,
  mkProductItems,
  newtypeProductId,
  newtypeProductItem,
  newtypeProductItemKey,
  ordProductId,
  ordProductItem,
  ordProductItemKey,
  product,
  productCategoryId,
  productId,
  productIdIsSymbol,
  productIsSymbol,
  productItemKey,
  productName,
  productPrice,
  productSeq,
  productSeqIsSymbol,
  showMap,
  showMaybe1,
  showProductId,
  showProductItem,
  showProductItemKey,
  udecodeProductId
};
